export default __webpack_public_path__ + "static/media/landing5.5df5f5b7.png";